import React, { Component } from 'react';
import axios from 'axios'

class AdminActions extends Component {
    state = { 
        actions: []
     } 
    componentDidMount(){
        axios.get("/api/actions/get/pending").then(res=>{
            this.setState({actions: res.data.actions})
        })
    }
    render() { 
        let actionsHtml = []
        this.state.actions.forEach(action => {
            actionsHtml.push(action.description)
        });
        return (
            <div>
                {actionsHtml}
            </div>
        );
    }
}
 
export default AdminActions;